// HTML压缩工具
(function() {
    'use strict';
    
    // 压缩HTML内容
    function minifyHTML(html) {
        return html
            // 移除HTML注释（保留条件注释）
            .replace(/<!--(?!\s*(?:\[if [^\]]+]|<!|>))(?:(?!-->).)*-->/g, '')
            // 移除多余空白
            .replace(/\s+/g, ' ')
            // 移除标签间的空白
            .replace(/>\s+</g, '><')
            // 移除属性值周围的引号（如果可能）
            .replace(/\s+>/g, '>')
            // 压缩内联样式
            .replace(/style="([^"]*)"/g, function(match, style) {
                return 'style="' + style.replace(/\s+/g, ' ').trim() + '"';
            })
            // 压缩内联脚本
            .replace(/<script[^>]*>([\s\S]*?)<\/script>/g, function(match, script) {
                const minifiedScript = script
                    .replace(/\/\*[\s\S]*?\*\//g, '') // 移除块注释
                    .replace(/\/\/.*$/gm, '') // 移除行注释
                    .replace(/\s+/g, ' ') // 压缩空白
                    .trim();
                return match.replace(script, minifiedScript);
            })
            .trim();
    }
    
    // 优化图片标签
    function optimizeImages() {
        document.querySelectorAll('img').forEach(img => {
            // 添加延迟加载
            if (!img.hasAttribute('loading')) {
                img.setAttribute('loading', 'lazy');
            }
            
            // 添加alt属性（如果没有）
            if (!img.hasAttribute('alt')) {
                img.setAttribute('alt', '');
            }
            
            // 优化srcset
            if (img.hasAttribute('srcset')) {
                const srcset = img.getAttribute('srcset');
                const optimizedSrcset = srcset
                    .split(',')
                    .map(src => src.trim())
                    .filter(src => src.length > 0)
                    .join(', ');
                img.setAttribute('srcset', optimizedSrcset);
            }
        });
    }
    
    // 移除未使用的CSS类
    function removeUnusedClasses() {
        const allClasses = new Set();
        const usedClasses = new Set();
        
        // 收集所有CSS类
        document.querySelectorAll('*[class]').forEach(el => {
            el.className.split(/\s+/).forEach(cls => {
                if (cls.trim()) allClasses.add(cls.trim());
            });
        });
        
        // 检查哪些类被使用
        document.querySelectorAll('*[class]').forEach(el => {
            el.className.split(/\s+/).forEach(cls => {
                if (cls.trim()) usedClasses.add(cls.trim());
            });
        });
        
        // 移除未使用的类
        const unusedClasses = [...allClasses].filter(cls => !usedClasses.has(cls));
        console.log('未使用的CSS类:', unusedClasses);
    }
    
    // 压缩内联样式
    function minifyInlineStyles() {
        document.querySelectorAll('*[style]').forEach(el => {
            const style = el.getAttribute('style');
            const minifiedStyle = style
                .replace(/\s+/g, ' ')
                .replace(/;\s*/g, ';')
                .replace(/:\s*/g, ':')
                .trim();
            el.setAttribute('style', minifiedStyle);
        });
    }
    
    // 优化链接
    function optimizeLinks() {
        document.querySelectorAll('a[href]').forEach(link => {
            const href = link.getAttribute('href');
            
            // 添加rel="noopener"到外部链接
            if (href.startsWith('http') && !href.includes(window.location.hostname)) {
                if (!link.hasAttribute('rel')) {
                    link.setAttribute('rel', 'noopener');
                } else if (!link.getAttribute('rel').includes('noopener')) {
                    link.setAttribute('rel', link.getAttribute('rel') + ' noopener');
                }
            }
        });
        
        // 优化hreflang标签
        document.querySelectorAll('link[hreflang]').forEach(link => {
            const hreflang = link.getAttribute('hreflang');
            if (hreflang && hreflang !== 'x-default') {
                // 确保hreflang值格式正确
                const normalizedHreflang = hreflang.toLowerCase().replace('_', '-');
                if (hreflang !== normalizedHreflang) {
                    link.setAttribute('hreflang', normalizedHreflang);
                }
            }
        });
    }
    
    // 初始化优化
    function initOptimizations() {
        optimizeImages();
        minifyInlineStyles();
        optimizeLinks();
        removeUnusedClasses();
    }
    
    // 页面加载完成后运行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOptimizations);
    } else {
        initOptimizations();
    }
    
    // 导出函数供外部使用
    window.HTMLOptimizer = {
        minifyHTML: minifyHTML,
        optimizeImages: optimizeImages,
        minifyInlineStyles: minifyInlineStyles,
        optimizeLinks: optimizeLinks,
        removeUnusedClasses: removeUnusedClasses
    };
    
})();
